import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  border-radius: 50%;
  height: 3rem;
  width: 3rem;

  .icon.show-expanded {
    display: none;
  }

  &.UltraPremio img {
    transition: transform 0.3s ease;
  }

  &.UltraPremio:hover img {
    transform: scale(1.1);
  }

  .info {
    display: none;
    width: 0;
    transition: width 0.5s ease-in-out;
  }

  .info.show-expanded {
    display: inline-block;
    position: absolute;
    width: 100%;
  }
`;
